import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomFieldsService } from './custom-fields.service';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  exports: [],
  providers: [CustomFieldsService],
})
export class CustomFieldsModule {}
